/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUserTypeRequest = 'Admin' | 'ServiceProvider' | 'RepairShop' | 'Repairer' | 'All';

export const EUserTypeRequest = {
    Admin: 'Admin' as EUserTypeRequest,
    ServiceProvider: 'ServiceProvider' as EUserTypeRequest,
    RepairShop: 'RepairShop' as EUserTypeRequest,
    Repairer: 'Repairer' as EUserTypeRequest,
    All: 'All' as EUserTypeRequest
};

